import { enClientPortalAssetListPage } from './AssetList/AssetListPage'

export const enClientPortalAssetListPages = {
    assetListPage: enClientPortalAssetListPage,
}
